import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import resourceModel from "src/models/resource"
import collection from "src/hocs/collection"

const configuration = {
  engine: entity,
  to: `resources`,
  model: resourceModel,
  query: {
    limit: 0,
  },
}

export default config =>
  compose(
    collection(props => ({
      ...configuration,
      query: props.query || configuration.query,
      ...(isFunction(config) ? config(props) : config),
    })),
  )
